// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.

// You can define here the conversion functions (to string) for the custom varTypes of your solution
// See ../generic/ConversionToString.js for some examples
export const CUSTOM_VAR_TYPES_TO_STRING_FUNCTIONS = {
  // myVarType: 'myConversionToStringFunction'
};
